module.exports = __webpack_public_path__ + "static/img/czxh.8ea341a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slwh/czxh.png
// module id = Qdkh
// module chunks = 0